export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: null,
    },
    data() {
        return {
            localValue: this.value
        }
    },
    watch: {
        localValue() {
            this.$emit('update:value', this.localValue);
            this.$emit('change', this.localValue);
        },
        value: {
            handler() {
                this.localValue = this.value;
                this.handleValue();
            },
            immediate: true
        },
    },
    methods:{
        handleValue() {

        },
    }
}
